module.exports = __webpack_public_path__ + "static/img/us-1.a89a4ff.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/contactpic/us-1.jpg
// module id = z00f
// module chunks = 51